const BASE_URL = {
    DEV: 'https://lqt-b2b-api.dev.yanolja.in',
    PRODUCTION: 'https://lqt-b2b-api.yanolja.com'
};

export { BASE_URL }


// WEBPACK FOOTER //
// ./src/api/enum/ApiPath.js